const U = (id, sig) => `https://images.unsplash.com/${id}?crop=entropy&cs=srgb&fm=jpg&ixid=${sig}&ixlib=rb-4.1.0&q=85`;

export const PROJECTS = [
  {
    slug: "mandate-malwa",
    title: "Mandate Malwa",
    client: "Vidhan Sabha Candidate — Malwa Region, MP",
    category: "Political Campaign",
    year: "2023",
    img: U("photo-1695042849689-f682ec337576", "M3w4NjA2OTV8MHwxfHNlYXJjaHwyfHxJbmRpYSUyMHBvbGl0aWNhbCUyMHJhbGx5JTIwY3Jvd2QlMjBmbGFnc3xlbnwwfHx8fDE3OTEwNTQxNzF8MA"),
    desc: "A full-stack Vidhan Sabha campaign for a first-time candidate in a seat lost three times in a row. We rebuilt the narrative around local water and mandi issues, mapped every booth, ran a 90-day war room and converted a 14,000-vote deficit into a decisive win.",
    deliverables: ["Campaign Strategy", "Booth Mapping", "Daily War Room", "Chunavi Geet", "Rally Management"],
    metrics: [
      { label: "Booths managed", value: "287" },
      { label: "Voters reached", value: "2.1L" },
      { label: "Win margin", value: "+22K" },
    ],
  },
  {
    slug: "digital-sansad",
    title: "Digital Sansad",
    client: "Lok Sabha Constituency — Central India",
    category: "Digital War Room",
    year: "2024",
    img: U("photo-1716047269726-56a1781be730", "M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxJbmRpYSUyMHBvbGl0aWNhbCUyMHJhbGx5JTIwY3Jvd2QlMjBmbGFnc3xlbnwwfHx8fDE3OTEwNTQxNzF8MA"),
    desc: "A 24x7 digital war room for a Lok Sabha campaign — 2,400 WhatsApp groups, a Hindi reels factory producing 60+ assets a day, influencer tie-ups across eight assembly segments and a rapid-response desk that answered every attack within the hour.",
    deliverables: ["WhatsApp Network", "Reels Factory", "Rapid Response", "Influencer Outreach", "Trend Command"],
    metrics: [
      { label: "Impressions", value: "9.4Cr" },
      { label: "WhatsApp groups", value: "2,400" },
      { label: "Response time", value: "<1 hr" },
    ],
  },
  {
    slug: "nagar-ki-awaaz",
    title: "Nagar Ki Awaaz",
    client: "Mayoral Campaign — Indore Nagar Nigam",
    category: "Ground Outreach",
    year: "2022",
    img: U("photo-1632261811725-4697edf73a48", "M3w4NjA2OTV8MHwxfHNlYXJjaHwxfHxJbmRpYSUyMHBvbGl0aWNhbCUyMHJhbGx5JTIwY3Jvd2QlMjBmbGFnc3xlbnwwfHx8fDE3OTEwNTQxNzF8MA"),
    desc: "An 85-ward Indore Nagar Nigam campaign built on the ground — from Rajwada to Vijay Nagar. Door-to-door tracking app, ward-level sankalp patra, 32 micro-surveys and a nukkad-sabha calendar that put the candidate in every mohalla twice before polling day.",
    deliverables: ["Door-to-Door App", "Ward Surveys", "Nukkad Sabha Calendar", "Voter List Analytics", "IVR Outreach"],
    metrics: [
      { label: "Wards covered", value: "85" },
      { label: "Doors knocked", value: "1.1L" },
      { label: "Surveys run", value: "32" },
    ],
  },
  {
    slug: "hamara-mp",
    title: "Hamara MP",
    client: "State Government Department — Madhya Pradesh",
    category: "Government & IEC",
    year: "2024",
    img: U("photo-1709832279012-293766967250", "M3w4NjY2NzZ8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjBlbGVjdGlvbiUyMGNhbXBhaWduJTIwbWVkaWElMjBwcmVzcyUyMG1pY3JvcGhvbmV8ZW58MHx8fHwxNzkxMDU0MTgyfDA"),
    desc: "A statewide IEC campaign for a flagship welfare scheme — Hindi, Bundeli, Malwi and Gondi creatives, LED-van routes through 50+ districts, nukkad natak troupes and a WhatsApp helpline that onboarded beneficiaries directly.",
    deliverables: ["IEC Strategy", "Multilingual Creatives", "LED Van Routes", "Nukkad Natak", "WhatsApp Helpline"],
    metrics: [
      { label: "Districts", value: "50+" },
      { label: "Languages", value: "4" },
      { label: "Enrolments", value: "3.2L" },
    ],
  },
  {
    slug: "bundelkhand-diaries",
    title: "Bundelkhand Diaries",
    client: "Tourism Board & Cultural Trust",
    category: "Film & Production",
    year: "2025",
    img: U("photo-1710987760447-e1777b1de284", "M3w3NTY2NzV8MHwxfHNlYXJjaHw0fHxCaG9wYWwlMjBNYWRoeWElMjBQcmFkZXNoJTIwY2l0eSUyMGxha2V8ZW58MHx8fHwxNzkxMDU0MTc3fDA"),
    desc: "A six-part documentary series on the forts, rivers and folk music of Bundelkhand — shot across four months with drone units and a Hindi narration track that travelled from YouTube to regional television.",
    deliverables: ["Documentary Series", "Drone Cinematography", "Hindi Narration", "Original Score", "Festival Submissions"],
    metrics: [
      { label: "Views", value: "6.2M" },
      { label: "Episodes", value: "6" },
      { label: "Festival selections", value: "3" },
    ],
  },
  {
    slug: "super-corridor-living",
    title: "Super Corridor Living",
    client: "Premium Real Estate Developer — Indore",
    category: "Brand & Corporate",
    year: "2025",
    img: U("photo-1728537520855-515e2ee9aaa7", "M3w3NTY2NzV8MHwxfHNlYXJjaHwyfHxCaG9wYWwlMjBNYWRoeWElMjBQcmFkZXNoJTIwY2l0eSUyMGxha2V8ZW58MHx8fHwxNzkxMDU0MTc3fDA"),
    desc: "Brand identity and launch campaign for a premium township on Indore's Super Corridor. Performance ads across Meta and Google, a 3D walkthrough film and a site-visit funnel that tripled footfall in the first quarter.",
    deliverables: ["Brand Identity", "Launch Film", "Performance Marketing", "3D Walkthrough", "Site-Visit Funnel"],
    metrics: [
      { label: "Site visits", value: "3x" },
      { label: "Bookings", value: "₹120Cr" },
      { label: "Cost per lead", value: "-41%" },
    ],
  },
  {
    slug: "chunavi-geet",
    title: "Chunavi Geet",
    client: "Regional Party — Madhya Pradesh",
    category: "Film & Production",
    year: "2023",
    img: U("photo-1760262491785-4c4adcf649e8", "M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxJbmRpYW4lMjBzdHJlZXQlMjBtYXJrZXQlMjBuaWdodCUyMG5lb24lMjBjaXR5fGVufDB8fHx8MTc5MTA1NDE4N3ww"),
    desc: "A twelve-track campaign album in Hindi, Malwi and Nimadi — written, composed and shot in-house, then distributed through LED vans, ringtones, WhatsApp statuses and reels across the state.",
    deliverables: ["Lyrics & Composition", "Studio Production", "Music Videos", "Ringtone Distribution", "Reels Cutdowns"],
    metrics: [
      { label: "Tracks", value: "12" },
      { label: "Plays", value: "4.8Cr" },
      { label: "Dialects", value: "3" },
    ],
  },
  {
    slug: "vidya-indore",
    title: "Vidya Indore",
    client: "Education Group — Indore & Bhopal",
    category: "Brand & Corporate",
    year: "2024",
    img: U("photo-1760262492479-85a9832b9034", "M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxJbmRpYW4lMjBzdHJlZXQlMjBtYXJrZXQlMjBuaWdodCUyMG5lb24lMjBjaXR5fGVufDB8fHx8MTc5MTA1NDE4N3ww"),
    desc: "Admissions campaign for a multi-campus education group — parent-first storytelling, alumni films, Hindi-English bilingual creatives and a lead system tied to counsellor callbacks within ten minutes.",
    deliverables: ["Admissions Strategy", "Alumni Films", "Bilingual Creatives", "Lead System", "Counsellor CRM"],
    metrics: [
      { label: "Admissions", value: "+68%" },
      { label: "Leads", value: "14K" },
      { label: "Callback time", value: "10 min" },
    ],
  },
];

export const CATEGORIES = [
  "All",
  "Political Campaign",
  "Digital War Room",
  "Ground Outreach",
  "Government & IEC",
  "Film & Production",
  "Brand & Corporate",
];
